import {FC, Fragment, PropsWithChildren, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getIsSettingsLoaded, getIsSessionChecked, getIsVotingOpen} from "modules/selectors";
import {fetchSettings, requestUser} from "modules/actions";
import {PagePreloader, VotePeriod} from "components";

export const HocData: FC<PropsWithChildren<unknown>> = ({children}) => {
	const dispatch = useDispatch();
	const isSettingsLoaded = useSelector(getIsSettingsLoaded);
	const isSessionChecked = useSelector(getIsSessionChecked);
	const isVotingOpen = useSelector(getIsVotingOpen);

	useEffect(() => {
		dispatch(requestUser());
		dispatch(fetchSettings());
	}, [dispatch]);

	if (!isSessionChecked || !isSettingsLoaded) {
		return <PagePreloader />;
	}

	if (!isVotingOpen) {
		return <VotePeriod />;
	}

	return <Fragment>{children}</Fragment>;
};
